import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { ArchiveRestore, Trash2 } from "lucide-react";
import { Link } from "react-router-dom";
import { Button, Card } from "@/components/ui";
import { api } from "@/lib/api";
import type { Chat } from "@/lib/types";

export default function Archived() {
  const qc = useQueryClient();
  const chats = useQuery({ queryKey: ["chats", "archived"], queryFn: () => api.get<Chat[]>("/api/chats?archived=true") });
  const refresh = () => qc.invalidateQueries({ queryKey: ["chats"] });
  const restore = useMutation({ mutationFn: (id: string) => api.patch(`/api/chats/${id}`, { archived: false }), onSuccess: refresh });
  const remove = useMutation({ mutationFn: (id: string) => api.delete(`/api/chats/${id}`), onSuccess: refresh });
  return (
    <Card title="Archived chats">
      {chats.data?.length === 0 && <p className="text-sm text-zinc-500">Nothing archived.</p>}
      <ul className="divide-y divide-zinc-200 dark:divide-zinc-800">
        {chats.data?.map((c) => (
          <li key={c.id} className="flex items-center justify-between gap-4 py-2">
            <Link to={`/c/${c.id}`} className="min-w-0 truncate text-sm hover:underline">
              {c.title}
            </Link>
            <div className="flex shrink-0 gap-1">
              <Button variant="ghost" size="icon" onClick={() => restore.mutate(c.id)} aria-label="Unarchive" title="Unarchive">
                <ArchiveRestore size={16} />
              </Button>
              <Button variant="ghost" size="icon" onClick={() => confirm(`Delete "${c.title}"?`) && remove.mutate(c.id)} aria-label="Delete" title="Delete">
                <Trash2 size={16} />
              </Button>
            </div>
          </li>
        ))}
      </ul>
    </Card>
  );
}
